export const enum ProcessingRedirectOptions {
  DE_GENERAL = 'DE_GENERAL',
  EN_GENERAL = 'EN_GENERAL',
  DE_OATH = 'DE_OATH',
  STRIPE = 'STRIPE',
}

export const enum RecipientSelectionModeOptions {
  CRITERIA_MATCH = 'CRITERIA_MATCH',
  RECIPIENTS_LIST = 'RECIPIENTS_LIST',
}
